import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import { ScheduleStackParamList } from '@/types/navigation';
import ScheduleScreen from '@/screens/schedule/ScheduleScreen';
import TimeOffScreen from '@/screens/timeoff/TimeOffScreen';
import AssembleTimeOffScreen from '@/screens/timeoff/AssembleTimeOffScreen';
import TimeOffDetailScreen from '@/screens/timeoff/TimeOffDetailScreen';
import RespondToSubScreen from '@/screens/timeoff/RespondToSubScreen';
import ApprovalsScreen from '@/screens/timeoff/ApprovalsScreen';
import { colors, font } from '@/theme/chalkCourt';

const Stack = createStackNavigator<ScheduleStackParamList>();

/**
 * Schedule tab stack: the weekly schedule plus the time-off screen it
 * links to. Keeps time off reachable without adding another bottom tab.
 */
const ScheduleNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerStyle: { backgroundColor: colors.bg, shadowColor: 'transparent' },
        headerTintColor: colors.ink,
        headerTitleStyle: { fontFamily: font.displayBold, fontSize: 20 },
        headerBackTitleVisible: false,
        cardStyle: { backgroundColor: colors.bg },
      }}>
      <Stack.Screen
        name="ScheduleHome"
        component={ScheduleScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen name="TimeOff" component={TimeOffScreen} options={{ title: 'Time Off' }} />
      <Stack.Screen
        name="TimeOffAssemble"
        component={AssembleTimeOffScreen}
        options={{ title: 'Request' }}
      />
      <Stack.Screen
        name="TimeOffDetail"
        component={TimeOffDetailScreen}
        options={{ title: 'Time Off' }}
      />
      <Stack.Screen
        name="TimeOffRespond"
        component={RespondToSubScreen}
        options={{ title: 'Cover Request' }}
      />
      <Stack.Screen name="Approvals" component={ApprovalsScreen} options={{ title: 'Approvals' }} />
    </Stack.Navigator>
  );
};

export default ScheduleNavigator;
